<script setup>
import { Link, useForm } from '@inertiajs/inertia-vue3';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import Buttons from '@/Components/Buttons.vue';
import { ref } from 'vue';
defineProps({
    canResetPassword: Boolean,
    status: String,
});

const form = useForm({
    email: '',
    password: '',
    remember: false
});

const submit = () => {
    form.post(route('login'), {
        onFinish: () => form.reset('password'),
    });
};

// Año
const currentYear = ref(new Date().getFullYear());

</script>

<template>
    <div class="bg-no-repeat bg-cover bg-center lg:min-h-screen" style="background-image: url(/img/login/bg.png);">
        <div class="min-h-screen flex items-cemter"><!-- FIX background -->
            <div class="max-w-xl xl:max-w-3xl w-full z-10 m-auto p-4 md:p-6">
                <div class="flex flex-row gap-5 items-center justify-center">
                    <div class="w-[400px] min-h-[500px] shadow-xl bg-white p-8 rounded-lg flex flex-col justify-center">
                        <div class="mb-4 text-center w-full">
                            <Link href="/" class="text-center flex justify-center items-center w-full">
                                <div class="flex w-full justify-center mb-6">
                                    <div class="max-w-[230px] w-full">
                                        <img v-if="confGlobal?.value?.COMPANY_LOGO_PATH" :src="confGlobal.value.COMPANY_LOGO_PATH" alt="Logo" class="mx-auto max-h-[80px]">
                                        <img v-else src="/documents/mycompany/logos/logo-full.png" alt="Logo" class="mx-auto max-h-[80px]">
                                    </div>
                                </div>
                            </Link>
                        </div>

                        <div class="sm:w-full text-center m-auto lg:m-0">
                            <h1 class="text-xl md:text-xl 2xl:text-2xl font-bold mb-6">Ingresa a tu cuenta</h1>
                        </div>

                        <div v-if="Object.keys(form.errors).length > 0" class="mb-4 text-sm text-red-600 bg-red-100 p-3 rounded-md">
                                <p v-for="(error, key) in form.errors" :key="key" class="text-xs">• {{ error }}</p>
                        </div>

                        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                            {{ status }}
                        </div>
                        <form @submit.prevent="submit">
                            <div>
                                <label for="email" class="block font-medium text-sm text-gray-700">Usuario / Email</label>
                                <input id="email" type="email" class="border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
                            </div>
                            <div class="mt-4">
                                <label for="password" class="block font-medium text-sm text-gray-700">Password</label>
                                <input id="password" type="password" class="border-gray-300 focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
                            </div>
                            <div class="block mt-4">
                                <label class="flex items-center cursor-pointer">
                                    <input type="checkbox" name="remember" v-model="form.remember" class="rounded border-gray-300 text-blue-600 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50" />
                                    <span class="ml-2 text-sm text-gray-600">Recuerdame</span>
                                </label>
                            </div>
                            <div class="flex items-center justify-end mt-4">
                                <Link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                Olvidaste tu password?
                                </Link>

                                <Buttons type="submit" color="blue" class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                    Ingresar
                                </Buttons>
                            </div>
                        </form>
                    </div>
                    <div class="hidden xl:grid w-[300px] min-h-[500px]  rounded-lg shadow-lg">
                        <Splide :options="{ rewind: true, perPage: 1, type: 'loop', autoplay: 'true', pagination: boolean = false, arrows: boolean = false, gap: '1em', }" class="rounded-lg grid h-full splide-height-rlg">
                            <div class="splide__arrows"></div>
                            <SplideSlide class="rounded-lg h-full">
                                <div class="bg-[url('/img/login/slider-01.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300 ">
                                    <div class="rounded-lg h-full">

                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide class="rounded-lg h-full">
                                <div class="bg-[url('/img/login/slider-02.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300">
                                    <div class="rounded-lg h-full">
                                    </div>
                                </div>
                            </SplideSlide>
                            <SplideSlide class="rounded-lg h-full">
                                <div class="bg-[url('/img/login/slider-03.jpg')] bg-no-repeat bg-center bg-cover rounded-lg h-full border border-gray-300">
                                    <div class="rounded-lg h-full">

                                    </div>
                                </div>
                            </SplideSlide>
                        </Splide>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="bg-white fixed bottom-0 w-full shadow-xl">
        <div class="flex items-center justify-center h-10">
           <div class="hidden md:block">
                <p>© Unens Ecommerce Rev. {{ confGlobal.value.UNENS_VERSION }} - <a class="font-semibold" target="_blank" href="https://unens.com">Unens.com</a> | All Rights Reserved {{ currentYear }}</p>
            </div>
            <div class="md:hidden block">
                <p class="text-center text-xs">© Unens Ecommerce Rev. {{ confGlobal.value.UNENS_VERSION }} - <a class="font-semibold" target="_blank" href="https://unens.com">Unens.com</a></p>
                <p class="text-center text-xs">All Rights Reserved {{ currentYear }}</p>
            </div>
        </div>
    </div>
</template>
